import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogContent, DialogTitle, Stack, TextField } from '@mui/material';
import { useAppDispatch } from '../../../../app/hooks';
import { createCategoryAsync, updateCategoryAsync } from './categorySlice';
import { CategoryDialogProps } from './types';
import { CategoryCreatePayloadRequest, CategoryUpdatePayloadRequest } from '../../../../generated/api';

const CategoryDialog = ({ open, close, category }: CategoryDialogProps) => {
  const dispatch = useAppDispatch();
  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');

  useEffect(() => {
    if (!category) return;
    setName(category.name);
    setDescription(category.description);
  }, [category]);

  const handleSubmit = () => {
    const payload: CategoryCreatePayloadRequest | CategoryUpdatePayloadRequest = {
      name: name,
      description: description
    };
    if (category) {
      dispatch(updateCategoryAsync({ id: category.id, data: payload }));
    } else {
      dispatch(createCategoryAsync(payload));
    }
    setName('');
    setDescription('');
    close();
  };

  const handleClose = () => {
    setName('');
    setDescription('');
    close();
  };

  return (
    <Box>
      <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
        <DialogTitle>{category ? 'Edit Category' : 'New Category'}</DialogTitle>
        <DialogContent>
          <Stack spacing={2} marginTop={2}>
            <TextField label="Name" value={name} onChange={({ target }) => setName(target.value)} />
            <TextField
              multiline
              label="Description"
              value={description}
              onChange={({ target }) => setDescription(target.value)}
            />
            <Button variant="contained" onClick={handleSubmit}>
              Submit
            </Button>
          </Stack>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default CategoryDialog;
